import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styles from './DocumentList.module.scss'
import PrivateWealthEmailLink from 'components/Shared/PrivateWealthEmailLink/PrivateWealthEmailLink'

const NoDocuments = (props) => {
  const { documentType } = props

  const emptyText = (documentType) => {
    switch (documentType) {
      case 'my uploads':
        return (
          <Fragment>
              You haven’t uploaded any documents.
              Click the Upload Document button to get started. Think something is missing?
            Please <PrivateWealthEmailLink message="contact your team." />
          </Fragment>
        )
      default:
        return (
          <Fragment>
            No documents have been shared with you. Think something is missing?
            Please <PrivateWealthEmailLink message="contact your team." />
          </Fragment>
        )
    }
  }

  return (
    <div className={styles.noDocuments}>
      <span className={styles.Header}>{emptyText(documentType)}</span>
    </div>
  )
}

NoDocuments.defaultProps = {
  documentType: 'documents',
}

NoDocuments.propTypes = {
  documentType: PropTypes.string
}

export default NoDocuments



// WEBPACK FOOTER //
// ./src/components/Client/DocumentList/NoDocuments.jsx